export default "__VITE_ASSET__kgnTipVR__"